export const TOWN_NOT_FOUND_STATUS = 468
export const UNABLE_TO_CANCEL_FINE_STATUS = 480
export const PARKING_NOT_FOUND_STATUS = 481
export const ALREADY_CANCELLED_FINE_STATUS = 486
export const OUT_OF_DATE_FINE_STATUS = 488
export const NON_CANCELLABLE_FINE_STATUS = 489
export const FINE_NOT_FOUND_STATUS = 490
